// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1u0Pc6YECB9-2xpQ1zTYiX","title":"_1GjCJNftnTUVvjNnDY5QzZ","ojk-logo":"_2DSwVLjQLP_iET7ZqMXjc6"};